import styled from 'styled-components';

export const ProgramBgWrapper = styled.div`
    background-image: url('/image/program_bg.jpeg');
    background-size: cover;
    background-attachment: fixed;
`;
export const MainBgWrapper = styled.div`
    background-image: url('/image/bg_paper.png');
    background-color: #F9F4EF;
`;
export const HomeBgWrapper = styled.div`
    background-image: url('/image/home_bg.png');
    background-color: #F9F4EF;
    background-attachment: fixed;
    background-size: cover;
`;
export const PriceBgWrapper = styled.div`
    background-image: url('/image/price_bg.jpeg');
    background-size: cover;
`;
